/**
 * Custom Cart Drawer for Little Aangan Live Theme
 * Handles DOM rendering and Discount logic
 */

(function () {
    'use strict';

    const SIDEBAR_ID = 'halo-cart-sidebar';
    const OFFERS_SIDEBAR_ID = 'halo-offers-sidebar';

    let isRefreshing = false;

    // Open/Close UI
    window.openCart = function () {
        const sidebar = document.getElementById(SIDEBAR_ID);
        if (!sidebar) return;

        sidebar.classList.remove('translate-x-full');
        sidebar.classList.add('ccd-open');
        document.body.classList.add('cart-sidebar-show', 'ccd-cart-open', 'ccd-cart-scroll-lock');
        
        refreshCartDrawer();
    };

    window.closeCart = function () {
        const sidebar = document.getElementById(SIDEBAR_ID);
        const offersSidebar = document.getElementById(OFFERS_SIDEBAR_ID);

        if (sidebar) {
            sidebar.classList.add('translate-x-full');
            sidebar.classList.remove('ccd-open');
        }
        if (offersSidebar) offersSidebar.classList.remove('ccd-open');

        document.body.classList.remove('cart-sidebar-show', 'ccd-cart-open', 'ccd-cart-scroll-lock');
    };

    window.openOffers = function () {
        const offersSidebar = document.getElementById(OFFERS_SIDEBAR_ID);
        if (offersSidebar) {
            offersSidebar.classList.add('ccd-open');
            populateOffers();
        }
    };

    window.closeOffers = function () {
        const offersSidebar = document.getElementById(OFFERS_SIDEBAR_ID);
        if (offersSidebar) {
            offersSidebar.classList.remove('ccd-open');
        }
    };

    // Helper Functions
    function formatMoneyCustom(cents, originalText) {
        if (!originalText) return '';
        const match = originalText.trim().match(/^([^\d\s,]+)/);
        const prefix = match ? match[1] : 'Rs. ';
        const dollars = (cents / 100).toFixed(2);
        const formattedDollars = dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return prefix + (originalText.includes(' ') ? ' ' : '') + formattedDollars;
    }

    function updateCartCountBadges(count) {
        const icons = document.querySelectorAll('.cart-count-bubble, .CartCount, [href*="/cart"] .absolute');
        icons.forEach(icon => {
            if (icon) icon.textContent = count;
        });
    }

    // Milestone Savings Evaluation & Off-Price Calculation
    function evaluateMilestoneSavings(currentTotalCents) {
        if (!window.CartMilestones || !window.CartMilestones.length) return null;
        
        // Cart subtotal in ₹
        const cartTotalRupees = currentTotalCents / 100;
        
        // Sort ascending by target
        const sorted = [...window.CartMilestones].sort((a, b) => (parseFloat(a.target) || 0) - (parseFloat(b.target) || 0));
        
        let highestUnlocked = null;
        for (let i = 0; i < sorted.length; i++) {
            if (cartTotalRupees >= (parseFloat(sorted[i].target) || 0)) {
                highestUnlocked = sorted[i];
            }
        }
        
        if (!highestUnlocked) return null;
        
        let savingAmountRupees = 0;
        let discountLabel = highestUnlocked.label || 'Reward';
        const tierType = highestUnlocked.type || 'percent';
        const tierVal = parseFloat(highestUnlocked.value) || 0;
        
        if (tierType === 'percent') {
            savingAmountRupees = Math.round(cartTotalRupees * (tierVal / 100));
            if (!highestUnlocked.label) discountLabel = `${tierVal}% OFF`;
        } else if (tierType === 'fixed') {
            savingAmountRupees = Math.min(cartTotalRupees, tierVal);
            if (!highestUnlocked.label) discountLabel = `₹${tierVal} OFF`;
        } else if (tierType === 'shipping') {
            savingAmountRupees = 0;
            if (!highestUnlocked.label) discountLabel = 'Free Shipping';
        } else {
            savingAmountRupees = 0;
            if (!highestUnlocked.label) discountLabel = 'Special Reward';
        }
        
        return {
            tier: highestUnlocked,
            savingAmountCents: savingAmountRupees * 100,
            savingAmountRupees: savingAmountRupees,
            discountLabel: discountLabel,
            code: highestUnlocked.code || ''
        };
    }

    function syncMilestonePricing(fixedFooter, subtotalCents, shopifyDiscountCents) {
        if (!fixedFooter) return;
        
        const subtotalEl = fixedFooter.querySelector('[data-cart-subtotal-value]');
        const totalValEl = fixedFooter.querySelector('[data-cart-total-value]');
        const milestoneRow = fixedFooter.querySelector('#ccd-milestone-saving-row');
        const milestoneText = fixedFooter.querySelector('#ccd-milestone-saving-text');
        const milestoneAmount = fixedFooter.querySelector('#ccd-milestone-saving-amount');
        
        const milestoneInfo = evaluateMilestoneSavings(subtotalCents);
        const hasShopifyDiscount = shopifyDiscountCents > 0;
        
        if (milestoneInfo && milestoneInfo.savingAmountCents > 0 && !hasShopifyDiscount) {
            if (milestoneRow) {
                milestoneRow.style.display = 'flex';
                if (milestoneText) milestoneText.textContent = `${milestoneInfo.discountLabel}`;
                if (milestoneAmount) milestoneAmount.textContent = `- ₹${milestoneInfo.savingAmountRupees.toLocaleString('en-IN')}`;
            }
            
            const netPayableCents = Math.max(0, subtotalCents - milestoneInfo.savingAmountCents);
            if (totalValEl) {
                totalValEl.textContent = formatMoneyCustom(netPayableCents, totalValEl.textContent);
                totalValEl.setAttribute('data-cart-total-raw', netPayableCents);
            }
        } else if (milestoneInfo && milestoneInfo.tier && (milestoneInfo.tier.type === 'shipping' || milestoneInfo.tier.type === 'custom')) {
            if (milestoneRow) {
                milestoneRow.style.display = 'flex';
                if (milestoneText) milestoneText.textContent = `${milestoneInfo.discountLabel}`;
                if (milestoneAmount) milestoneAmount.textContent = 'FREE';
            }
        } else {
            if (milestoneRow) {
                milestoneRow.style.display = 'none';
            }
        }
    }

    window.proceedToCheckout = function(event) {
        if (event) event.preventDefault();
        
        let discountCode = '';
        
        // 1. Check coupon input / cookie
        const discountCookie = document.cookie.split('; ').find(row => row.trim().startsWith('discount_code='));
        if (discountCookie) {
            const val = decodeURIComponent(discountCookie.split('=')[1]).trim();
            if (val && val.toLowerCase() !== 'clear') discountCode = val;
        }
        
        // 2. Check stored discount in localStorage
        if (!discountCode) {
            const stored = localStorage.getItem('storedDiscount');
            if (stored && stored.toLowerCase() !== 'clear') discountCode = stored;
        }
        
        // 3. If no manual code, check highest unlocked milestone tier code
        if (!discountCode) {
            const totalRawEl = document.querySelector('#halo-cart-sidebar [data-cart-subtotal-raw]') || document.querySelector('#halo-cart-sidebar [data-cart-total-raw]');
            const totalCents = totalRawEl ? parseInt(totalRawEl.getAttribute('data-cart-subtotal-raw') || totalRawEl.getAttribute('data-cart-total-raw') || '0') : 0;
            const milestoneInfo = evaluateMilestoneSavings(totalCents);
            if (milestoneInfo && milestoneInfo.code) {
                discountCode = milestoneInfo.code;
            }
        }
        
        if (discountCode) {
            window.location.href = `/checkout?discount=${encodeURIComponent(discountCode)}`;
        } else {
            window.location.href = '/checkout';
        }
    };

    function syncCouponField() {
        const discountCookie = document.cookie.split('; ').find(row => row.trim().startsWith('discount_code='));
        const liveInput = document.getElementById('ccd-live-coupon-input');
        const liveStatus = document.getElementById('ccd-live-coupon-status');
        
        if (discountCookie) {
            const code = decodeURIComponent(discountCookie.split('=')[1]).trim();
            
            if (code.toLowerCase() === 'clear') {
                localStorage.removeItem('storedDiscount');
                document.cookie = "discount_code=; path=/; max-age=0;";
                if (liveInput && liveInput.value.toLowerCase() === 'clear') liveInput.value = '';
                if (liveStatus) liveStatus.style.display = 'none';
                
                const cartDiscountInput = document.getElementById('cart-discount-input');
                if (cartDiscountInput) cartDiscountInput.value = '';
                
                return;
            }

            if (liveInput && !liveInput.value) {
                liveInput.value = code;
            }
            
            const cartDiscountInput = document.getElementById('cart-discount-input');
            if (cartDiscountInput) cartDiscountInput.value = code;
            if (liveStatus) {
                liveStatus.style.display = 'flex';
                liveStatus.classList.remove('hidden');
                liveStatus.style.color = '#4A2E1B'; // dark brown
                const savedLabel = localStorage.getItem('storedDiscountSaving');
                if (savedLabel) {
                    liveStatus.innerHTML = `✓ <strong>"${code}"</strong> applied — You save <strong>${savedLabel}</strong>! 🎉`;
                } else {
                    liveStatus.innerHTML = `✓ <strong>"${code}"</strong> will be applied at checkout`;
                }
            }
        } else {
            // Check if a milestone discount code is unlocked
            const totalRawEl = document.querySelector('#halo-cart-sidebar [data-cart-subtotal-raw]') || document.querySelector('#halo-cart-sidebar [data-cart-total-raw]');
            const totalCents = totalRawEl ? parseInt(totalRawEl.getAttribute('data-cart-subtotal-raw') || totalRawEl.getAttribute('data-cart-total-raw') || '0') : 0;
            const milestoneInfo = evaluateMilestoneSavings(totalCents);
            
            if (milestoneInfo && milestoneInfo.code) {
                if (liveStatus) {
                    liveStatus.style.display = 'flex';
                    liveStatus.classList.remove('hidden');
                    liveStatus.style.color = '#4A2E1B';
                    liveStatus.innerHTML = `🎉 Milestone unlocked: <strong>"${milestoneInfo.code}"</strong> will auto-apply at checkout!`;
                }
            } else {
                if (liveStatus) {
                    liveStatus.style.display = 'none';
                    liveStatus.classList.add('hidden');
                }
            }
            if (liveInput) {
                liveInput.value = '';
            }
        }
    }

    function updateDrawerDOM(rawHtml) {
        const sidebar = document.getElementById(SIDEBAR_ID);
        if (!sidebar) return;

        const wrapper = sidebar.querySelector('.previewCart-wrapper');
        if (!wrapper) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(rawHtml, 'text/html');

        // Extract milestone
        const milestoneData = doc.getElementById('ccd-ajax-milestone-data');
        const count = milestoneData ? parseInt(milestoneData.getAttribute('data-count') || '0') : 0;
        updateCartCountBadges(count);

        // Replace Cart Content
        const ajaxCartContent = doc.getElementById('ccd-ajax-cart-content');
        if (ajaxCartContent) {
            wrapper.innerHTML = ajaxCartContent.innerHTML;
        }

        // Replace Milestone Container & Script
        const milestoneDataEl = doc.getElementById('ccd-milestone-container');
        const milestoneEl = sidebar ? sidebar.querySelector('#ccd-milestone-container') : null;
        if (milestoneEl && milestoneDataEl) {
            milestoneEl.innerHTML = milestoneDataEl.innerHTML;
            const newScript = milestoneDataEl.querySelector('script');
            if (newScript) {
                try {
                    // Re-execute CartMilestones initialization
                    eval(newScript.textContent);
                } catch (e) {
                    console.error('Milestones eval error', e);
                }
            }
        }

        const mainCartMilestoneEl = document.querySelector('#MainCart-content #ccd-milestone-container');
        if (mainCartMilestoneEl && milestoneDataEl) {
            mainCartMilestoneEl.innerHTML = milestoneDataEl.innerHTML;
        }

        // Replace Footer
        const footerData = doc.getElementById('ccd-ajax-footer-data');
        const fixedFooter = sidebar.querySelector('.ccd-fixed-footer');

        if (footerData && fixedFooter) {
            const subtotal = footerData.getAttribute('data-subtotal') || footerData.getAttribute('data-total') || '';
            const rawSubtotal = parseInt(footerData.getAttribute('data-raw-subtotal') || footerData.getAttribute('data-raw-total') || '0');
            const total = footerData.getAttribute('data-total') || '';
            const rawTotal = parseInt(footerData.getAttribute('data-raw-total') || '0');
            const savings = footerData.getAttribute('data-savings') || '';
            const discountCount = parseFloat(footerData.getAttribute('data-discount-count') || '0');

            const subtotalValEl = fixedFooter.querySelector('[data-cart-subtotal-value]');
            if (subtotalValEl) {
                subtotalValEl.textContent = subtotal;
                subtotalValEl.setAttribute('data-cart-subtotal-raw', rawSubtotal);
            }

            const totalValEl = fixedFooter.querySelector('[data-cart-total-value]');
            if (totalValEl) {
                totalValEl.textContent = total;
                totalValEl.setAttribute('data-cart-total-raw', rawTotal);
            }

            const savingsEl = fixedFooter.querySelector('[data-cart-savings]');
            if (savingsEl) {
                if (discountCount > 0) {
                    savingsEl.style.display = 'flex';
                } else {
                    savingsEl.style.display = 'none';
                }
            }

            // Sync milestone live calculations with footer
            syncMilestonePricing(fixedFooter, rawSubtotal, discountCount);

            if (count > 0) {
                fixedFooter.style.display = 'block';
            } else {
                fixedFooter.style.display = 'none';
            }
        }

        syncCouponField();
    }

    async function refreshCartDrawer() {
        if (isRefreshing) return;
        isRefreshing = true;

        const sidebar = document.getElementById(SIDEBAR_ID);
        const wrapper = sidebar ? sidebar.querySelector('.previewCart-wrapper') : null;

        if (wrapper) {
            wrapper.style.opacity = '0.5';
            wrapper.style.pointerEvents = 'none';
        }

        try {
            const res = await fetch('/?sections=cart-drawer&t=' + Date.now());
            if (!res.ok) throw new Error('Section rendering failed');

            const sectionsData = await res.json();
            const rawHtml = sectionsData['cart-drawer'];
            if (rawHtml) {
                updateDrawerDOM(rawHtml);
            }
        } catch (e) {
            console.error('CCD: refresh failed', e);
        } finally {
            if (wrapper) {
                wrapper.style.opacity = '1';
                wrapper.style.pointerEvents = 'auto';
            }
            isRefreshing = false;
        }
    }

    const cartQueues = {};

    window.updateQuantityOptimistic = async function(itemKey, newQty, itemRow, delta) {
        if (!itemKey) return;
        const sidebar = document.getElementById(SIDEBAR_ID);
        if (!sidebar) return;

        const totalValEl = sidebar.querySelector('[data-cart-total-value]');
        const display = itemRow ? itemRow.querySelector('.ccd-qty-display') : null;

        if (itemRow && totalValEl) {
            const unitPrice = parseFloat(itemRow.getAttribute('data-item-price') || '0');
            const totalRaw = parseInt(totalValEl.getAttribute('data-cart-total-raw') || '0');
            const newTotalRaw = Math.max(0, totalRaw + (delta * unitPrice));
            totalValEl.textContent = formatMoneyCustom(newTotalRaw, totalValEl.textContent);
            totalValEl.setAttribute('data-cart-total-raw', newTotalRaw);
        }

        if (newQty === 0) {
            if (cartQueues[itemKey]) {
                clearTimeout(cartQueues[itemKey].timeout);
                delete cartQueues[itemKey];
            }

            if (itemRow) {
                itemRow.style.transition = 'all 0.35s ease';
                itemRow.style.opacity = '0';
                itemRow.style.transform = 'translateX(100%)';
                setTimeout(() => itemRow.remove(), 350);
            }

            try {
                const res = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ id: itemKey, quantity: 0, sections: 'cart-drawer' })
                });
                const data = await res.json();
                if (data.sections && data.sections['cart-drawer']) {
                    updateDrawerDOM(data.sections['cart-drawer']);
                } else {
                    await refreshCartDrawer();
                }
            } catch (e) { console.error(e); }
            return;
        }

        if (display) display.textContent = newQty;
        if (display) display.style.opacity = '0.5';

        if (cartQueues[itemKey]) clearTimeout(cartQueues[itemKey].timeout);

        cartQueues[itemKey] = {
            quantity: newQty,
            timeout: setTimeout(async () => {
                try {
                    const res = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                        body: JSON.stringify({ id: itemKey, quantity: newQty, sections: 'cart-drawer' })
                    });
                    const data = await res.json();
                    if (data.sections && data.sections['cart-drawer']) {
                        updateDrawerDOM(data.sections['cart-drawer']);
                    } else {
                        await refreshCartDrawer();
                    }
                } catch (e) { console.error(e); } finally {
                    if (display) display.style.opacity = '1';
                    delete cartQueues[itemKey];
                }
            }, 300)
        };
    };

    function populateOffers() {
        const offersContent = document.getElementById('ccd-offers-content');
        if (!offersContent) return;

        const offers = [
            { code: 'LITTLE10', label: 'LITTLE10', desc: 'Get 10% off your order' },
            { code: 'FREESHIP', label: 'FREESHIP', desc: 'Free shipping on this order' }
        ];

        const storedDiscount = localStorage.getItem('storedDiscount') || '';

        let html = '<div class="p-6">';
        html += '<h3 class="text-sm font-black text-dark-brown uppercase tracking-widest mb-4">Available Offers</h3>';
        html += '<div class="space-y-4">';

        offers.forEach(offer => {
            const isApplied = storedDiscount.toUpperCase() === offer.code.toUpperCase();
            html += `
                <div class="flex items-center justify-between border border-sage/20 rounded-xl p-4 bg-sage/5">
                    <div class="flex-1 min-w-0">
                        <div class="font-bold text-sage font-sans text-sm mb-1">${offer.label}</div>
                        <div class="text-xs text-dark-brown/70 font-medium">${offer.desc}</div>
                    </div>
                    <button type="button" onclick="applyDiscount('${offer.code}')" class="px-4 py-2 text-xs font-bold uppercase tracking-wider rounded-lg border ${isApplied ? 'bg-sage border-sage text-white' : 'bg-transparent border-sage text-sage'} hover:brightness-105 transition-colors">
                        ${isApplied ? 'APPLIED ✓' : 'APPLY'}
                    </button>
                </div>
            `;
        });

        html += '</div>';
        html += `
            <div class="mt-8 border-t border-sage/10 pt-6">
                <div class="text-xs font-bold text-dark-brown/70 uppercase tracking-widest mb-3">Have another code?</div>
                <div class="flex gap-2">
                    <input type="text" id="ccd-offers-manual-input" class="flex-1 bg-white border border-sage/20 rounded-xl px-4 py-2.5 text-sm font-bold text-dark-brown uppercase focus:ring-sage/30 placeholder:text-dark-brown/30" placeholder="Enter coupon code" value="${storedDiscount}">
                    <button type="button" onclick="applyDiscount(document.getElementById('ccd-offers-manual-input').value)" class="px-6 bg-dark-brown text-white rounded-xl font-bold text-[11px] uppercase tracking-wider hover:bg-black transition-colors min-w-[90px]">Apply</button>
                </div>
            </div>
        `;
        html += '</div>';
        offersContent.innerHTML = html;
    }

    window.applyDiscount = async function(code) {
        const cleanCode = code ? code.trim() : '';
        const liveInput = document.getElementById('ccd-live-coupon-input');
        const liveStatus = document.getElementById('ccd-live-coupon-status');
        const liveInputPage = document.getElementById('ccd-live-coupon-input-page');
        const liveStatusPage = document.getElementById('ccd-live-coupon-status-page');
        const applyBtn = document.getElementById('ccd-live-coupon-apply-btn');
        const applyBtnPage = document.getElementById('ccd-live-coupon-apply-btn-page');

        const setBtnLoading = (btn) => {
            if (!btn) return;
            const w = btn.offsetWidth;
            const h = btn.offsetHeight;
            if(w) btn.style.width = w + 'px';
            if(h) btn.style.height = h + 'px';
            btn.style.display = 'flex';
            btn.style.alignItems = 'center';
            btn.style.justifyContent = 'center';
            btn.style.padding = '0';
            btn._originalHTML = btn.innerHTML;
            btn.disabled = true;
            btn.innerHTML = '<span class="material-symbols-outlined animate-spin" style="font-size:16px; margin-right:4px;">autorenew</span> Applying...';
        };
        setBtnLoading(applyBtn);
        setBtnLoading(applyBtnPage);

        const wrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (wrapper) wrapper.style.opacity = '0.5';

        try {
            if (cleanCode === '') {
                localStorage.removeItem('storedDiscount');
                localStorage.removeItem('storedDiscountSaving');
                document.cookie = "discount_code=; path=/; max-age=0;";
                
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({ discount: '' })
                });

                if (liveInput) liveInput.value = '';
                if (liveInputPage) liveInputPage.value = '';
                if (liveStatus) { liveStatus.style.display = 'none'; liveStatus.classList.add('hidden'); }
                if (liveStatusPage) { liveStatusPage.style.display = 'none'; liveStatusPage.classList.add('hidden'); }
                
                const restoreBtn = (btn) => {
                    if (!btn) return;
                    btn.disabled = false;
                    btn.innerHTML = btn._originalHTML || 'APPLY';
                    btn.style.width = '';
                    btn.style.height = '';
                    btn.style.display = '';
                    btn.style.alignItems = '';
                    btn.style.justifyContent = '';
                    btn.style.padding = '';
                };
                restoreBtn(applyBtn);
                restoreBtn(applyBtnPage);
                if (wrapper) wrapper.style.opacity = '1';

                await refreshCartDrawer();
                const offersSidebar = document.getElementById(OFFERS_SIDEBAR_ID);
                if (offersSidebar && offersSidebar.classList.contains('ccd-open')) populateOffers();
                return;
            }

            // XHR to bypass potential hooks
            await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('POST', '/cart/update.js', true);
                xhr.setRequestHeader('Content-Type', 'application/json');
                xhr.setRequestHeader('Accept', 'application/json');
                xhr.onload = () => { if (xhr.status >= 200 && xhr.status < 300) resolve(); else reject(); };
                xhr.onerror = () => reject();
                xhr.send(JSON.stringify({ discount: cleanCode }));
            });

            await new Promise(r => setTimeout(r, 400));

            const cartData = await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', '/cart.js?t=' + Date.now(), true);
                xhr.setRequestHeader('Accept', 'application/json');
                xhr.onload = () => { if(xhr.status >= 200 && xhr.status < 300) resolve(JSON.parse(xhr.responseText)); else reject(); };
                xhr.onerror = () => reject();
                xhr.send();
            });

            const dcEntry = Array.isArray(cartData.discount_codes) ? cartData.discount_codes.find(dc => String(dc.code).toUpperCase() === String(cleanCode).toUpperCase()) : null;
            const applicableTrue = !!(dcEntry && dcEntry.applicable === true);
            const applicableFalse = !!(dcEntry && dcEntry.applicable === false);
            const hasDiscount = (cartData.total_discount || 0) > 0;

            let inCartLevel = false;
            if (Array.isArray(cartData.cart_level_discount_applications)) {
                for (let i = 0; i < cartData.cart_level_discount_applications.length; i++) {
                    const app = cartData.cart_level_discount_applications[i];
                    if (app && app.title && String(app.title).toUpperCase() === String(cleanCode).toUpperCase()) {
                        inCartLevel = true;
                        break;
                    }
                }
            }

            let inLineItems = false;
            if (Array.isArray(cartData.items)) {
                for (let i = 0; i < cartData.items.length; i++) {
                    const allocs = cartData.items[i].line_level_discount_allocations || [];
                    for (let j = 0; j < allocs.length; j++) {
                        const da = allocs[j].discount_application;
                        if (da && da.title && String(da.title).toUpperCase() === String(cleanCode).toUpperCase()) {
                            inLineItems = true;
                            break;
                        }
                    }
                    if (inLineItems) break;
                }
            }

            let isCodeValid = false;
            if (applicableTrue) isCodeValid = true;
            if (hasDiscount) isCodeValid = true;
            if (inCartLevel) isCodeValid = true;
            if (inLineItems) isCodeValid = true;
            if (applicableFalse && !hasDiscount && !inCartLevel && !inLineItems) isCodeValid = false;

            if (isCodeValid) {
                const totalSavedCents = cartData.total_discount || 0;

                const allApps = [
                    ...(cartData.discount_applications || []),
                    ...(cartData.cart_level_discount_applications || [])
                ];
                const matchedApp = allApps.find(app =>
                    app.title && String(app.title).toUpperCase() === String(cleanCode).toUpperCase()
                );

                let lineItemSavedCents = 0;
                (cartData.items || []).forEach(item => {
                    (item.line_level_discount_allocations || []).forEach(alloc => {
                        const da = alloc.discount_application;
                        if (da && da.title && String(da.title).toUpperCase() === String(cleanCode).toUpperCase()) {
                            lineItemSavedCents += alloc.amount || 0;
                        }
                    });
                });

                let discountValueLabel = '';
                let successMessage = '';

                if (matchedApp) {
                    const vtype = matchedApp.value_type || '';
                    if (vtype === 'shipping') {
                        discountValueLabel = 'Free Shipping';
                        successMessage = `✓ <strong>"${cleanCode}"</strong> applied — <strong>Free Shipping</strong> on your order! 🚚`;
                    } else if (totalSavedCents > 0) {
                        discountValueLabel = 'Rs. ' + (totalSavedCents / 100).toFixed(2);
                    } else if (vtype === 'percentage') {
                        discountValueLabel = parseFloat(matchedApp.value).toFixed(0) + '% OFF';
                    } else if (vtype === 'fixed_amount') {
                        const amt = lineItemSavedCents || (parseFloat(matchedApp.value) * 100);
                        if (amt > 0) discountValueLabel = 'Rs. ' + (amt / 100).toFixed(2);
                    }
                } else {
                    const amt = totalSavedCents || lineItemSavedCents;
                    if (amt > 0) discountValueLabel = 'Rs. ' + (amt / 100).toFixed(2);
                }

                if (!successMessage) {
                    successMessage = discountValueLabel
                        ? `✓ <strong>"${cleanCode}"</strong> applied — You save <strong>${discountValueLabel}</strong>! 🎉`
                        : `✓ <strong>"${cleanCode}"</strong> will be applied at checkout`;
                }

                if (discountValueLabel) localStorage.setItem('storedDiscountSaving', discountValueLabel);
                else localStorage.removeItem('storedDiscountSaving');
                
                localStorage.setItem('storedDiscount', cleanCode);
                document.cookie = `discount_code=${encodeURIComponent(cleanCode)}; path=/; max-age=604800;`;
                await fetch('/discount/' + encodeURIComponent(cleanCode));

                const setSuccess = (statusEl) => {
                    if (!statusEl) return;
                    statusEl.style.display = 'flex';
                    statusEl.classList.remove('hidden');
                    statusEl.style.color = '#4A2E1B';
                    statusEl.innerHTML = successMessage;
                };
                setSuccess(liveStatus);
                setSuccess(liveStatusPage);
            } else {
                localStorage.removeItem('storedDiscount');
                localStorage.removeItem('storedDiscountSaving');
                document.cookie = "discount_code=; path=/; max-age=0;";
                const setError = (statusEl) => {
                    if (!statusEl) return;
                    statusEl.style.display = 'flex';
                    statusEl.classList.remove('hidden');
                    statusEl.style.color = '#dc2626'; // red-600
                    const failMsg = (applicableFalse && !hasDiscount && !inCartLevel && !inLineItems)
                        ? `❌ <strong>"${cleanCode}"</strong> doesn't apply to your current cart`
                        : `❌ <strong>"${cleanCode}"</strong> is invalid or not applicable`;
                    statusEl.innerHTML = failMsg;
                };
                setError(liveStatus);
                setError(liveStatusPage);
            }

            const restoreBtn = (btn) => {
                if (!btn) return;
                btn.disabled = false;
                btn.innerHTML = btn._originalHTML || 'APPLY';
                btn.style.width = '';
                btn.style.height = '';
                btn.style.display = '';
                btn.style.alignItems = '';
                btn.style.justifyContent = '';
                btn.style.padding = '';
            };
            restoreBtn(applyBtn);
            restoreBtn(applyBtnPage);
            if (wrapper) wrapper.style.opacity = '1';

            await refreshCartDrawer();
            const offersSidebar = document.getElementById(OFFERS_SIDEBAR_ID);
            if (offersSidebar && offersSidebar.classList.contains('ccd-open')) populateOffers();

        } catch(e) {
            console.error('Discount apply failed', e);
        } finally {
            // Already restored above
        }
    };

    window.removeBundleOptimistic = async function(bundleId, keysString, rowEl, bundleTotal) {
        if (!bundleId || !keysString) return;
        const keys = keysString.split(',').filter(k => k.trim() !== '');
        
        if(rowEl) {
            rowEl.style.transition = 'all 0.35s ease';
            rowEl.style.opacity = '0';
            rowEl.style.transform = 'translateX(100%)';
            setTimeout(() => rowEl.remove(), 350);
        }

        const sidebar = document.getElementById(SIDEBAR_ID);
        if (sidebar) {
            const totalValEl = sidebar.querySelector('[data-cart-total-value]');
            if(totalValEl) {
                const totalRaw = parseInt(totalValEl.getAttribute('data-cart-total-raw') || '0');
                const newTotalRaw = Math.max(0, totalRaw - bundleTotal);
                totalValEl.textContent = formatMoneyCustom(newTotalRaw, totalValEl.textContent);
                totalValEl.setAttribute('data-cart-total-raw', newTotalRaw);
            }
        }

        try {
            const updates = {};
            keys.forEach(k => updates[k] = 0);

            await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ updates })
            });

            await refreshCartDrawer();
        } catch(e) {
            console.error(e);
            await refreshCartDrawer();
        }
    };

    document.addEventListener('DOMContentLoaded', () => {
        // Sync on load
        syncCouponField();

        // Hook up global Add To Cart events to open the drawer
        document.addEventListener('cart:open', () => {
            window.openCart();
        });
        
        // Expose openCartDrawer for inline scripts
        window.openCartDrawer = window.openCart;

        // Intercept standard Add To Cart forms
        document.addEventListener('submit', function(e) {
            const form = e.target.closest('form[action^="/cart/add"]');
            if (form) {
                if (form.classList.contains('no-ajax')) return;
                
                e.preventDefault();
                const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
                let originalText = '';
                if(submitBtn) {
                    originalText = submitBtn.innerHTML;
                    submitBtn.disabled = true;
                    submitBtn.innerHTML = '<span class="material-symbols-outlined animate-spin" style="font-size:16px;">autorenew</span> Adding...';
                }

                const formData = new FormData(form);
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData
                })
                .then(response => {
                    if(!response.ok) throw new Error('Error adding to cart');
                    return response.json();
                })
                .then(data => {
                    window.openCart();
                })
                .catch((error) => {
                    console.error('Error adding to cart:', error);
                    window.location.href = '/cart'; // fallback
                })
                .finally(() => {
                    if(submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.innerHTML = originalText;
                    }
                });
            }
        });

        // Intercept Cart icon clicks (prevent going to /cart page)
        document.addEventListener('click', function(e) {
            const cartLink = e.target.closest('a[href="/cart"], a[href="' + window.Shopify.routes.root + 'cart"]');
            if (cartLink && !cartLink.classList.contains('no-ajax')) {
                e.preventDefault();
                window.openCart();
            }
        });
    });

})();
